/**
 * @generated SignedSource<<80bb6c167d9951fa213b84141e510a53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type geoLocationGroupQueue$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId?: string;
        readonly " $fragmentSpreads": FragmentRefs<"topicLinkTopic">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "geoLocationGroupQueue";
};
export type geoLocationGroupQueue$key = {
  readonly " $data"?: geoLocationGroupQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "geoLocationGroupQueue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "topicLinkTopic"
                    }
                  ],
                  "type": "Topic",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};

(node as any).hash = "c2eeeb72271d5679673046311afa80e4";

export default node;
